const handlers = new WeakMap();

export default {
  mounted(el, binding) {
    const state = { callback: binding.value };
    state.handler = (event) => {
      if (!el.contains(event.target)) {
        state.callback(event);
      }
    };
    handlers.set(el, state);
    document.addEventListener('click', state.handler);
    document.addEventListener('touchstart', state.handler);
  },
  updated(el, binding) {
    handlers.get(el).callback = binding.value;
  },
  unmounted(el) {
    const state = handlers.get(el);
    document.removeEventListener('click', state.handler);
    document.removeEventListener('touchstart', state.handler);
    handlers.delete(el);
  },
};
